import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportScreenSwitch from '../Reports/ReportScreenSwitch';
import { changeStep } from '../../actions/reportActions';

class ReportPage extends Component {
  componentDidMount() {
    // eslint-disable-next-line react/prop-types
    const { changeStepToDefault } = this.props;
    changeStepToDefault(1);
  }

  render() {
    return (
      <>
        <ReportScreenSwitch />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeStepToDefault: (value) => dispatch(changeStep(value))
  };
};

export default connect(null, mapDispatchToProps)(ReportPage);
